export const STAGE_ITEMS = [
    { id: 0, color: '#fbe2d5' },
    { id: 1, color: '#f7c7ac' },
    { id: 2, color: '#ebddff' },
    { id: 3, color: '#dac1ff' },
    { id: 4, color: '#c0e6f5' },
    { id: 5, color: '#83cceb' },
    { id: 6, color: '#f0c8e4' },
    { id: 7, color: '#e0a0cc' },
];
